(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dci-cus-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  class DciCusSlider {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector('.dci-cus-viewport');
      this.track = root.querySelector('[data-dci-cus-track]');
      this.slides = Array.from(root.querySelectorAll('[data-dci-cus-slide]'));
      this.dots = Array.from(root.querySelectorAll('[data-dci-cus-dot]'));
      this.prevButton = root.querySelector('[data-dci-cus-prev]');
      this.nextButton = root.querySelector('[data-dci-cus-next]');
      this.progressBar = root.querySelector('[data-dci-cus-progress-bar]');
      this.counter = root.querySelector('[data-dci-cus-counter-current]');

      this.total = this.slides.length;
      this.current = 0;
      this.transition = root.dataset.transition || 'fade';
      this.autoplay = root.dataset.autoplay === 'true';
      this.delay = parseInt(root.dataset.autoplayDelay, 10) || 6000;
      this.loop = root.dataset.loop === 'true';
      this.pauseOnHover = root.dataset.pauseHover === 'true';

      this.timer = null;
      this.progressRAF = null;
      this.paused = false;
      this.observer = null;
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.initialized = false;

      if (!this.total || !this.track) return;

      this.bind();
      this.goTo(0, true);
      this.observe();
      this.initialized = true;
    }

    bind() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.prev());
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.next());
      }

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.index, 10);
          if (Number.isFinite(index)) this.goTo(index);
        });
      });

      this.root.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.prev();
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.next();
        }
      });

      if (this.pauseOnHover) {
        this.root.addEventListener('mouseenter', () => this.pause());
        this.root.addEventListener('mouseleave', () => this.resume());
      }

      this.root.addEventListener('focusin', () => this.pause());
      this.root.addEventListener('focusout', () => this.resume());

      this.track.addEventListener('touchstart', (event) => {
        const touch = event.changedTouches[0];
        this.touchStartX = touch.clientX;
        this.touchStartY = touch.clientY;
      }, { passive: true });

      this.track.addEventListener('touchend', (event) => {
        const touch = event.changedTouches[0];
        if (!touch) return;

        const diffX = this.touchStartX - touch.clientX;
        const diffY = Math.abs(this.touchStartY - touch.clientY);

        if (Math.abs(diffX) > 50 && Math.abs(diffX) > diffY) {
          diffX > 0 ? this.next() : this.prev();
        }
      }, { passive: true });
    }

    observe() {
      if (!('IntersectionObserver' in window)) {
        this.startAutoplay();
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.startAutoplay();
          } else {
            this.stopAutoplay();
          }
        });
      }, { threshold: 0.15 });

      this.observer.observe(this.root);
    }

    syncSlideVariables(slide) {
      if (!slide) return;

      const variables = [
        '--nav-background',
        '--nav-border-color',
        '--nav-icon-color',
        '--pagination-color',
        '--mobile-pagination-color',
        '--pagination-bottom',
        '--mobile-pagination-spacing',
        '--mobile-pagination-bottom',
        '--progress-track',
        '--progress-color'
      ];

      variables.forEach((name) => {
        const value = slide.style.getPropertyValue(name);
        if (value) this.root.style.setProperty(name, value);
      });
    }

    goTo(index, immediate) {
      if (!this.total) return;

      if (index < 0) {
        index = this.loop ? this.total - 1 : 0;
      }

      if (index >= this.total) {
        index = this.loop ? 0 : this.total - 1;
      }

      const target = this.slides[index];
      if (!target) return;

      /* Controls are siblings of the slides, so slide-scoped CSS variables
         do not inherit into them. Sync the active slide values to the root. */
      this.syncSlideVariables(target);

      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      if (this.transition === 'slide') {
        this.track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
      } else {
        this.track.style.transform = '';
      }

      this.current = index;
      this.updateDots();
      this.updateCounter();
      this.animate(target);
      this.restartProgress();

      if (!immediate) {
        this.resetAutoplay();
      }
    }

    next() {
      this.goTo(this.current + 1, false);
    }

    prev() {
      this.goTo(this.current - 1, false);
    }

    updateDots() {
      this.dots.forEach((dot, index) => {
        const active = index === this.current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    updateCounter() {
      if (this.counter) {
        this.counter.textContent = String(this.current + 1).padStart(2, '0');
      }
    }

    animate(slide) {
      const elements = slide.querySelectorAll('[data-animate-el]');

      elements.forEach((element) => {
        element.classList.remove('dci-animate-in');

        const order = parseInt(element.dataset.animateOrder, 10) || 0;
        const baseDelay = parseInt(slide.dataset.animationDelay, 10) || 0;

        element.style.transitionDelay = `${baseDelay + (order * 90)}ms`;

        if (slide.dataset.animation === 'none') {
          element.classList.add('dci-animate-in');
        } else {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              element.classList.add('dci-animate-in');
            });
          });
        }
      });
    }

    startAutoplay() {
      if (!this.autoplay || this.total < 2 || this.timer || this.paused) return;

      this.restartProgress();

      this.timer = setInterval(() => {
        this.next();
      }, this.delay);
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }

      if (this.progressRAF) {
        cancelAnimationFrame(this.progressRAF);
        this.progressRAF = null;
      }
    }

    resetAutoplay() {
      if (!this.autoplay) return;
      this.stopAutoplay();
      if (!this.paused) this.startAutoplay();
    }

    pause() {
      this.paused = true;
      this.stopAutoplay();
    }

    resume() {
      if (!this.paused) return;
      this.paused = false;
      this.startAutoplay();
    }

    restartProgress() {
      if (!this.progressBar) return;

      this.progressBar.style.transition = 'none';
      this.progressBar.style.width = '0%';
      void this.progressBar.offsetWidth;

      if (!this.autoplay) return;

      this.progressBar.style.transition = `width ${this.delay}ms linear`;

      requestAnimationFrame(() => {
        this.progressBar.style.width = '100%';
      });
    }

    destroy() {
      this.stopAutoplay();

      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }

  function initDciCusSliders(context) {
    const scope = context || document;

    scope.querySelectorAll('[data-dci-cus-slider]').forEach((element) => {
      if (!element.dciCusInstance) {
        element.dciCusInstance = new DciCusSlider(element);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initDciCusSliders());
  } else {
    initDciCusSliders();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initDciCusSliders(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-dci-cus-slider]').forEach((element) => {
      if (element.dciCusInstance) {
        element.dciCusInstance.destroy();
        element.dciCusInstance = null;
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dci-premium-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  class DciPremiumSlider {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-dci-track]');
      this.slides = Array.from(root.querySelectorAll('[data-dci-slide]'));
      this.dots = Array.from(root.querySelectorAll('[data-dci-dot]'));
      this.prevBtn = root.querySelector('[data-dci-prev]');
      this.nextBtn = root.querySelector('[data-dci-next]');
      this.progressBar = root.querySelector('[data-dci-progress-bar]');
      this.counterCurrent = root.querySelector('[data-dci-counter-current]');

      this.total = this.slides.length;
      this.current = 0;
      this.transition = root.dataset.transition || 'fade';
      this.autoplay = root.dataset.autoplay === 'true';
      this.delay = parseInt(root.dataset.autoplayDelay, 10) || 6000;
      this.loop = root.dataset.loop === 'true';
      this.pauseOnHover = root.dataset.pauseHover === 'true';

      this.timer = null;
      this.progressRAF = null;
      this.isPaused = false;
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.dragging = false;

      if (!this.total) return;

      this.bindEvents();
      this.goTo(0, true);
      this.observeVisibility();
    }

    bindEvents() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(parseInt(dot.dataset.index, 10));
        });
      });

      this.root.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.prev();
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.next();
        }
      });

      if (this.pauseOnHover) {
        this.root.addEventListener('mouseenter', () => this.pause());
        this.root.addEventListener('mouseleave', () => this.resume());
      }

      this.root.addEventListener('focusin', () => this.pause());
      this.root.addEventListener('focusout', () => this.resume());

      this.track.addEventListener('touchstart', (event) => {
        const touch = event.changedTouches[0];
        this.touchStartX = touch.clientX;
        this.touchStartY = touch.clientY;
        this.dragging = true;
      }, { passive: true });

      this.track.addEventListener('touchend', (event) => {
        if (!this.dragging) return;

        const touch = event.changedTouches[0];
        this.touchEndX = touch.clientX;

        const diffX = this.touchStartX - this.touchEndX;
        const diffY = Math.abs(this.touchStartY - touch.clientY);

        this.dragging = false;

        if (Math.abs(diffX) > 50 && Math.abs(diffX) > diffY) {
          diffX > 0 ? this.next() : this.prev();
        }
      }, { passive: true });
    }

    observeVisibility() {
      if (!('IntersectionObserver' in window)) {
        this.startAutoplay();
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.startAutoplay();
          } else {
            this.stopAutoplay();
          }
        });
      }, { threshold: 0.25 });

      this.observer.observe(this.root);
    }

    goTo(index, immediate) {
      if (this.total < 1) return;

      if (index < 0) {
        index = this.loop ? this.total - 1 : 0;
      }

      if (index >= this.total) {
        index = this.loop ? 0 : this.total - 1;
      }

      const next = this.slides[index];

      if (!next) return;

      /* Always reset every slide before activating the target.
         This prevents the final slide from inheriting an incorrect
         active/z-index state after repeated navigation. */
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;

        slide.classList.toggle('is-active', active);

        if (active) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });

      if (this.transition === 'slide') {
        this.track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
      } else {
        this.track.style.transform = '';
      }

      this.current = index;

      this.updateDots();
      this.updateCounter();
      this.runAnimations(next);
      this.restartProgress();

      if (!immediate) this.resetAutoplay();
    }

    next() {
      this.goTo(this.current + 1);
    }

    prev() {
      this.goTo(this.current - 1);
    }

    updateDots() {
      this.dots.forEach((dot, index) => {
        const active = index === this.current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    updateCounter() {
      if (this.counterCurrent) {
        this.counterCurrent.textContent = String(this.current + 1).padStart(2, '0');
      }
    }

    runAnimations(slide) {
      const elements = slide.querySelectorAll('[data-animate-el]');
      elements.forEach((element) => {
        element.classList.remove('dci-animate-in');
        void element.offsetWidth;

        const order = parseInt(element.dataset.animateOrder, 10) || 0;
        const baseDelay = parseInt(slide.dataset.animationDelay, 10) || 0;

        element.style.transitionDelay = `${baseDelay + order * 90}ms`;

        if (slide.dataset.animation === 'none') {
          element.classList.add('dci-animate-in');
        } else {
          requestAnimationFrame(() => element.classList.add('dci-animate-in'));
        }
      });
    }

    startAutoplay() {
      if (!this.autoplay || this.total < 2 || this.timer || this.isPaused) return;

      this.restartProgress();
      this.timer = setInterval(() => this.next(), this.delay);
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }

      if (this.progressRAF) {
        cancelAnimationFrame(this.progressRAF);
        this.progressRAF = null;
      }
    }

    resetAutoplay() {
      if (!this.autoplay) return;
      this.stopAutoplay();
      if (!this.isPaused) this.startAutoplay();
    }

    pause() {
      this.isPaused = true;
      this.stopAutoplay();
    }

    resume() {
      if (!this.isPaused) return;
      this.isPaused = false;
      this.startAutoplay();
    }

    restartProgress() {
      if (!this.progressBar) return;

      this.progressBar.style.transition = 'none';
      this.progressBar.style.width = '0%';
      void this.progressBar.offsetWidth;

      if (!this.autoplay) return;

      this.progressBar.style.transition = `width ${this.delay}ms linear`;

      requestAnimationFrame(() => {
        this.progressBar.style.width = '100%';
      });
    }
  }

  function initDciSliders(context) {
    const scope = context || document;
    scope.querySelectorAll('[data-dci-slider]').forEach((element) => {
      if (!element.dciInstance) {
        element.dciInstance = new DciPremiumSlider(element);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initDciSliders());
  } else {
    initDciSliders();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initDciSliders(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
